import { UserWithPermissionsAndRoles } from 'src/types/bootstrapTypes';
import { EnumOperateType, ShareInfo } from './types';
import { EnumShareType } from 'src/dict/dictEnum';

/** 获取 操作类型名称 */
export function getOperateTypeName(operateType?: EnumOperateType) {
  if (!operateType) return '';
  return operateType === EnumOperateType.view
    ? '仅可查看'
    : operateType === EnumOperateType.download
      ? '可查看/下载'
      : operateType === EnumOperateType.manage
        ? '管理'
        : '';
}

/** 查询指定用户在分享中的操作类型 */
export function getOperateType(
  shareInfo?: ShareInfo | null,
  user?: UserWithPermissionsAndRoles | null,
) {
  if (!shareInfo) return null;
  if (!user) return shareInfo.operate_type || null;
  const { share_user } = shareInfo;
  return (
    share_user?.find(v => v.user_id === user?.userId)?.operate_type ||
    shareInfo.operate_type ||
    null
  );
}
